(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astroida-play-win-popup"]) return;
  try {
    
if (!customElements.get('astroida-play-win-popup')) {
  customElements.define('astroida-play-win-popup', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.popupCleanup) return;
        const configNode = this.querySelector('[data-popup-config]');
        if (!configNode) return;
        try { this.popupCleanup = initializeAstroidaPopup(this, JSON.parse(configNode.textContent)); } catch { this.hidden = true; }
      });
    }
    disconnectedCallback() { this.popupCleanup?.(); this.popupCleanup = null; }
  });
}

function initializeAstroidaPopup(host, config) {
  const controller = new AbortController();
  const on = (target, name, fn) => target.addEventListener(name, fn, {signal: controller.signal});
  const q = selector => host.querySelector(selector);
  const scene = q('[data-popup-scene]'), canvas = q('canvas'), ctx = canvas.getContext('2d');
  const art = q('.ast-pw__art'), play = q('[data-popup-play]');
  const media = matchMedia('(max-width:749px)'), motion = matchMedia('(prefers-reduced-motion:reduce)');
  const W = 600, H = 300, images = {}, mode = 'playing';
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const layer = () => { const c = document.createElement('canvas'); c.width = W; c.height = H; return c; };
  const gelLayer = layer(), foamLayer = layer(), gelCtx = gelLayer.getContext('2d'), foamCtx = foamLayer.getContext('2d');
  const storageKey = 'astroida-popup-v1:' + (window.Shopify?.theme?.id || location.hostname) + ':' + config.sectionId;
  let reduced = motion.matches, ready = false, disposed = false, dismissed = false, shown = false, loading = false;
  let imagePromise, timer = 0, frame = 0, time = 0, lastTick = 0, started = 0, animateUntil = 0;
  let creatures = [], particles = [], pointer = {x:232,y:65}, previous = null, dragging = false;
  let manual = false, autoPhase = -1, autoPrevious = null, previousFocus = null;
  const dueAt = Date.now() + (config.designMode ? 150 : Math.max(0, Number(config.delay) || 0) * 1000);
  scene.disabled = !config.interactive;

  function seen() {
    if (config.designMode || config.frequency === 'always') return false;
    try {
      if (config.frequency === 'session') return sessionStorage.getItem(storageKey) === 'seen';
      const stamp = Number(localStorage.getItem(storageKey));
      return stamp > 0 && Date.now() >= stamp && Date.now() - stamp < 86400000;
    } catch { return false; }
  }
  function remember() {
    if (config.designMode || config.frequency === 'always') return;
    try {
      if (config.frequency === 'session') sessionStorage.setItem(storageKey, 'seen');
      else localStorage.setItem(storageKey, String(Date.now()));
    } catch {}
  }
  function allowed() {
    if (config.designMode) return true;
    if (!config.enabled || !config.allowed) return false;
    if (config.devices === 'mobile' && !media.matches || config.devices === 'desktop' && media.matches) return false;
    if (new URLSearchParams(location.search).get('view')?.includes('shave-win')) return false;
    try {
      const game = new URL(play.href, location.href), current = new URL(location.href);
      if (game.origin === current.origin && game.pathname === current.pathname) {
        if ([...game.searchParams].every(([key,value]) => current.searchParams.get(key) === value)) return false;
      }
    } catch {}
    return true;
  }
  function blocked() {
    if (document.documentElement.classList.contains('js-drawer-open')) return true;
    return [...document.querySelectorAll('.modal--is-active,.drawer--is-open,dialog[open],[aria-modal="true"]')].some(element => {
      if (host.contains(element) || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
  }
  function halt() { if (frame) cancelAnimationFrame(frame); frame = 0; dragging = false; previous = null; }
  function previewOffset() {
    const bar = document.getElementById('PBarNextFrame')?.parentElement, rect = bar?.getBoundingClientRect();
    const edge = document.documentElement.clientHeight || innerHeight;
    const overlap = rect && rect.height > 0 && rect.height < edge / 2 && rect.bottom >= edge - 2 ? clamp(edge - rect.top,0,160) : 0;
    host.style.setProperty('--ast-pw-preview-bar', overlap + 'px');
  }
  function schedule(wait = 500) {
    clearTimeout(timer);
    if (!disposed && !dismissed) timer = setTimeout(attempt, Math.max(wait, dueAt - Date.now()));
  }
  function loadImages() {
    if (imagePromise) return imagePromise;
    imagePromise = Promise.all(Object.entries(config.assets).map(([key,url]) => new Promise((resolve,reject) => {
      const image = new Image(); image.decoding = 'async';
      image.onload = () => { images[key] = image; resolve(); };
      image.onerror = reject; image.src = url;
    }))).then(() => { ready = Boolean(ctx && gelCtx && foamCtx); art.hidden = !ready; }).catch(() => { ready = false; art.hidden = true; });
    return imagePromise;
  }
  async function attempt() {
    if (disposed || dismissed || loading || !allowed() || !shown && seen()) return;
    if (document.hidden || blocked()) { schedule(1000); return; }
    loading = true; await loadImages(); loading = false;
    if (disposed || dismissed || !host.isConnected || !allowed()) return;
    if (document.hidden || blocked()) { schedule(500); return; }
    if (!shown && seen()) return;
    if (!shown) previousFocus = document.activeElement;
    previewOffset(); host.hidden = false; shown = true; remember(); resetAnimation();
  }
  function dismiss() {
    const restore = host.contains(document.activeElement);
    dismissed = true; host.hidden = true; clearTimeout(timer); halt();
    if (restore && previousFocus?.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({preventScroll:true});
  }
  function reconcile() {
    if (disposed || dismissed) return;
    if (blocked() || !allowed()) {
      if (!host.hidden) { host.hidden = true; halt(); }
      return;
    }
    if (host.hidden) schedule();
  }

  function pos(c, t) {
    let x = c.x + (reduced ? 0 : Math.sin(t * c.v + c.phase) * 6);
    let y = c.y + (reduced ? 0 : Math.sin(t * 2 + c.phase) * 4);
    if (!reduced && mode === 'playing' && pointer) {
      const dx = x - pointer.x, dy = y - pointer.y, d = Math.hypot(dx, dy);
      if (d < 135) { x += dx / Math.max(d, 1) * (135 - d) * .17; y += dy / Math.max(d, 1) * (135 - d) * .1; }
    }
    return {x, y};
  }
  function stroke(c, a, b, width, operation = 'source-over') {
    c.save(); c.globalCompositeOperation = operation; c.lineWidth = width;
    c.lineCap = 'round'; c.lineJoin = 'round'; c.strokeStyle = '#fff';
    c.beginPath(); c.moveTo(a.x, a.y); c.lineTo(b.x, b.y); c.stroke(); c.restore();
  }
  function distance(p, a, b) {
    const dx = b.x - a.x, dy = b.y - a.y, z = dx * dx + dy * dy;
    const k = z ? clamp(((p.x - a.x) * dx + (p.y - a.y) * dy) / z, 0, 1) : 0;
    return Math.hypot(p.x - a.x - k * dx, p.y - a.y - k * dy);
  }
  function resetLayers(){
    for(const c of [gelCtx,foamCtx]){c.globalCompositeOperation='source-over';c.clearRect(0,0,W,H)}
    gelCtx.globalAlpha=.48;gelCtx.fillStyle='#0084ff';gelCtx.fillRect(0,0,W,H);
    gelCtx.globalAlpha=.16;gelCtx.drawImage(images.gel,0,-230,600,840);gelCtx.globalAlpha=1;
    foamCtx.drawImage(images.foam,0,-230,600,840);
  }
  function spawn(){
    creatures=[95,232,369,506].map((x,i)=>({slot:i,x,y:105+(i%2)*11,phase:i*1.7,size:190+(i%2)*15,tilt:(i%2?1:-1)*.12,caught:false,v:1+i*.18}));
  }
  function shave(a,b){
    const dx=b.x-a.x,dy=b.y-a.y,len=Math.hypot(dx,dy);
    if(len<3||dy<Math.max(2,len*.2))return;
    const bladeA={x:a.x,y:a.y-34},bladeB={x:b.x,y:b.y-34};
    stroke(foamCtx,bladeA,bladeB,108,'destination-out');stroke(gelCtx,bladeA,bladeB,108,'destination-out');
    for(const c of creatures){
      if(c.caught)continue;const p=pos(c,time);if(distance(p,bladeA,bladeB)>56)continue;c.caught=true;
      if(!reduced)for(let i=0;i<8;i++)particles.push({x:p.x,y:p.y,vx:(Math.random()-.5)*180,vy:-Math.random()*190,life:.6,color:i%2?'#fff':'#45e9d0',r:3+Math.random()*4});
    }
  }
  function paint(dt){
    ctx.save();ctx.clearRect(0,0,W,H);ctx.drawImage(images.skin,0,-230,600,840);
    ctx.drawImage(gelLayer,0,0);ctx.globalAlpha=.74;ctx.drawImage(foamLayer,0,0);ctx.globalAlpha=1;
    for(const c of creatures){
      if(c.caught)continue;const p=pos(c,time),h=c.size,w=h*.36;
      ctx.save();ctx.translate(p.x,p.y);ctx.rotate(c.tilt+(reduced?0:Math.sin(time*2+c.phase)*.06));
      ctx.shadowColor='rgba(78,33,22,.24)';ctx.shadowBlur=2;ctx.shadowOffsetY=2;
      ctx.drawImage(images.hair,-w/2,-h*.32,w,h);ctx.restore();
    }
    if(pointer){
      ctx.save();ctx.translate(pointer.x,pointer.y);ctx.shadowColor='#542b2340';ctx.shadowBlur=20;ctx.shadowOffsetY=10;
      ctx.drawImage(images.razor,-100,-70,200,290);ctx.restore();
    }
    for(let i=particles.length-1;i>=0;i--){
      const p=particles[i];p.life-=dt;if(p.life<=0){particles.splice(i,1);continue}
      p.x+=p.vx*dt;p.y+=p.vy*dt;p.vy+=250*dt;ctx.globalAlpha=Math.min(p.life*2,1);ctx.fillStyle=p.color;ctx.fillRect(p.x,p.y,p.r,p.r*1.8);
    }
    ctx.restore();
  }


  function requestFrame() {
    if (!frame && ready && !disposed && !host.hidden && !document.hidden && !reduced && config.animate) frame = requestAnimationFrame(draw);
  }
  function draw(now) {
    frame = 0;
    if (disposed || !host.isConnected || host.hidden || document.hidden) return;
    const dt = Math.min(Math.max(0, now - lastTick) / 1000, .05); lastTick = now; time += dt;
    if (!manual) {
      const elapsed = (now - started) / 1000;
      const phase = elapsed < .9 ? -1 : elapsed < 2.8 ? 0 : elapsed < 3.5 ? -1 : elapsed < 5.4 ? 1 : -1;
      if (phase >= 0) {
        const local = clamp((elapsed - (phase === 0 ? .9 : 3.5)) / 1.9, 0, 1), x = phase === 0 ? 232 : 369;
        const next = {x,y:60 + local * 220}, from = autoPhase === phase && autoPrevious ? autoPrevious : {x,y:60};
        pointer = next;
        if (Math.hypot(next.x - from.x, next.y - from.y) >= 4) { shave(from,next); autoPrevious = next; } else autoPrevious = from;
      }
      autoPhase = phase;
    }
    paint(dt);
    if (now < animateUntil) requestFrame();
  }
  function resetAnimation() {
    halt(); if (!ready) return;
    manual = false; autoPhase = -1; autoPrevious = null; particles = []; time = 0; pointer = {x:232,y:65}; spawn(); resetLayers();
    started = lastTick = performance.now(); animateUntil = started + clamp(Number(config.duration) || 8, 3, 20) * 1000;
    paint(0); requestFrame();
  }
  function point(event) {
    const r = scene.getBoundingClientRect();
    return {x:clamp((event.clientX-r.left)/r.width*W,40,560),y:clamp((event.clientY-r.top)/r.height*H,20,295)};
  }
  on(scene,'pointerdown',event => {
    if (!ready || !config.interactive || event.button !== 0) return;
    manual = true; dragging = true; previous = point(event); pointer = previous;
    scene.setPointerCapture(event.pointerId); animateUntil = performance.now()+4000; paint(0); requestFrame();
  });
  on(scene,'pointermove',event => {
    if (!dragging) return;
    const next = point(event); pointer = next;
    if (Math.hypot(next.x-previous.x,next.y-previous.y) >= 3) { shave(previous,next); previous = next; }
    animateUntil = performance.now()+4000; paint(0); requestFrame();
  });
  for (const name of ['pointerup','pointercancel','lostpointercapture']) on(scene,name,() => { dragging=false;previous=null; });
  on(scene,'click',event => {
    if (event.detail !== 0 || !ready || !config.interactive) return;
    if (reduced || !config.animate) { pointer={x:232,y:265};shave({x:232,y:40},pointer);paint(0); } else resetAnimation();
  });
  on(q('[data-popup-replay]'),'click',resetAnimation);
  host.querySelectorAll('[data-popup-close]').forEach(button => on(button,'click',dismiss));
  on(play,'click',event => { if (config.designMode) { event.preventDefault(); return; } remember(); dismiss(); });
  on(document,'keydown',event => { if (event.key === 'Escape' && !host.hidden) dismiss(); });
  on(document,'modalOpen',reconcile); on(document,'drawerOpen',reconcile);
  on(media,'change',reconcile);
  on(window,'resize',() => { previewOffset();reconcile(); });
  on(motion,'change',() => { reduced=motion.matches; if(!host.hidden)resetAnimation(); });
  on(document,'visibilitychange',() => {
    if (document.hidden) halt();
    else { lastTick=performance.now(); if(host.hidden)reconcile();else if(lastTick<animateUntil)requestFrame(); }
  });
  on(window,'pagehide',halt);
  on(window,'pageshow',() => { if(!host.hidden){lastTick=performance.now();if(lastTick<animateUntil)requestFrame()}else reconcile(); });
  on(window,'blur',halt);
  on(window,'focus',() => { lastTick=performance.now(); if(lastTick<animateUntil)requestFrame(); });
  const observer = new MutationObserver(reconcile);
  observer.observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['class','hidden','aria-hidden','open']});
  if (config.designMode) {
    on(document,'shopify:section:select',event => { if(event.detail?.sectionId===config.sectionId){dismissed=false;clearTimeout(timer);attempt()} });
    on(document,'shopify:section:deselect',event => { if(event.detail?.sectionId===config.sectionId)dismiss() });
    on(document,'shopify:section:unload',event => { if(event.detail?.sectionId===config.sectionId)cleanup() });
  }
  schedule(0);
  function cleanup(){disposed=true;clearTimeout(timer);halt();observer.disconnect();controller.abort();host.hidden=true;}
  return cleanup;
}


  } catch(e) { console.error(e); }
})();
})();
